import { PageController } from '@client/components/_core/layout/PageController';
import { Button } from '@client/components/_ui/data-entry/ButtonModern';
import { errorMessage } from '@client/components/_ui/feedback/error-message/ErrorMessage';
import { DynamicFormSandbox } from '@client/components/dynamic-form/DynamicFormSandbox';
import { useTrpc } from '@client/hooks/api/useTrpc';
import { createFileRoute } from '@tanstack/react-router';
import { Tabs } from 'antd';
import { FlaskConical } from 'lucide-react';

export const Route = createFileRoute('/admin-console/advanced/playground')({
    component: AdminPlayground,
    staticData: {
        ui: {
            icon: FlaskConical,
            title: 'Admin playground',
            subtitle: 'Page for running various admin tests',
            widthVariant: 'default',
            menuDescription: 'Admin testing tools',
        },
        breadcrumb: {
            title: 'Admin playground',
        },
        permissions: ['super:admin'],
    },
});

function AdminPlayground() {
    const { trpc } = useTrpc();
    const { mutateAsync: indicatorNotificationTest } = trpc.admin.playground.indicatorNotificationTest.useMutation();
    const { mutateAsync: stripeTest } = trpc.admin.playground.stripeTest.useMutation();
    const handleIndicatorNotificationTest = async () => {
        try {
            await indicatorNotificationTest();
        } catch (error) {
            console.error(error);
            errorMessage.show(error);
        }
    };

    const handleStripeTest = async () => {
        try {
            const result = await stripeTest();
            console.log(result);
        } catch (error) {
            console.error(error);
            errorMessage.show(error);
        }
    };

    const tabItems = [
        {
            key: 'tests',
            label: 'API Tests',
            children: (
                <div className="space-y-4">
                    <Button type="secondary" onClick={handleIndicatorNotificationTest}>
                        Test indicator notification
                    </Button>
                    <Button type="secondary" onClick={handleStripeTest}>
                        Test stripe
                    </Button>
                </div>
            ),
        },
        {
            key: 'form-engine',
            label: 'Form Engine Demo',
            children: (
                <div style={{ height: 'calc(100vh - 220px)' }}>
                    <DynamicFormSandbox />
                </div>
            ),
        },
    ];

    return (
        <PageController route={Route}>
            <Tabs items={tabItems} defaultActiveKey="form-engine" />
        </PageController>
    );
}
